module.exports = __webpack_public_path__ + "assets/img/fslt.9ecaade4.jpg";